<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#6452c5" type="ball-clip-rotate" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="table-box section">

    <div class="client-box">
        <div class="row">
            <div class="col-md-4 col-sm-12 col-12">
                <div class="box">
                    <label>Client name:</label>
                    <p>{{clientName}}</p>
                </div>
                <div class="box">
                    <label>Contact name:</label>
                    <p>{{contactName}}</p>
                </div>
                <div class="box">
                    <label>Monitoring frequency:</label>
                    <p>{{monitoringFrequency}}</p>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 col-12">
                <div class="box">
                    <label>Email:</label>
                    <p>{{email}}</p>
                </div>
                <div class="box">
                    <label>Contact no:</label>
                    <p>{{contactNo}}</p>
                </div>
                <div class="box">
                    <label>Payment profile:</label>
                    <p>{{paymentProfile}}</p>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 col-12text-center">
                <div class="box">
                    <label>Expiry date:</label>
                    <p>{{expiryDate | date: "mediumDate"}}</p>
                </div>
                <div class="box" >
                    <label>Status:</label>
                    <p style="color:white">{{isActive}}</p>
                </div>
            </div>
        </div>
    </div>

<div class="search-wrap section">
    <!-- <mat-tab-group  animationDuration="0ms">
        <mat-tab label="Users ({{UserCount}})"><app-userlist></app-userlist></mat-tab>
        <mat-tab label="Teams ({{TeamCount}})"><app-teamlist></app-teamlist></mat-tab>            
    </mat-tab-group> -->

        <!-- <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#users">Users
                    (<span>{{UserCount}}</span>)
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#team">Teams
                    (<span>{{TeamCount}}</span>)
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div id="users" class="tab-pane active">
                <app-userlist></app-userlist>
            </div>
            <div id="team" class="tab-pane fade"><br>
                <app-teamlist></app-teamlist>
            </div>
        </div> -->

        <ul class="nav nav-tabs user-nav" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" data-testid="parameter-users-button" data-bs-toggle="tab" data-bs-target="#users" type="button" role="tab" aria-controls="usera" aria-selected="true">
                Users (<span>{{UserCount}}</span>)
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="profile-tab" data-testid="parameter-team-button" data-bs-toggle="tab" data-bs-target="#team" type="button" role="tab" aria-controls="team" aria-selected="false">
                Teams (<span>{{TeamCount}}</span>)
              </button>
            </li>       
          </ul>
          
          <div class="tab-content">
            <div id="users" class="tab-pane active" role="tabpanel">
                <app-userlist></app-userlist>
            </div>
            <div id="team" class="tab-pane fade" role="tabpanel"><br>
                <app-teamlist [stReportTypesClient]="stReportTypesClient"></app-teamlist>
            </div>        
        </div>
    </div>
</div>